package ru.astrainteractive.web.feature.main.resources

import ru.astrainteractive.kobwebx.core.resource.JSResource

object MainImagesR {
    val astralearner = JSResource.Image("images/astralearner.png")
    val empiremobile = JSResource.Image("images/empiremobile.png")
    val pitha = JSResource.Image("images/pitha.jpg")
}